module.exports = ".example-loading-shade {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.15);\n  z-index: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/components/sidebar/sidebar.css
// module id = ./src/app/main/components/sidebar/sidebar.css
// module chunks = main